import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { DownOutlined, SettingOutlined } from "@ant-design/icons";
//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Divider,
  Col,
  Collapse,
  Statistic,
  Table,
  Button,
  Dropdown,
  message,
  Space,
  Tooltip,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";

import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import appStatic from "../../../../config/appStatic";
import RepaymentSchedule from "./tabs/RepaymentSchedule";
import LoanDocuments from "./tabs/LoanDocuments";
import Notes from "./tabs/Notes";
import ClientRisk from "./tabs/ClientRisk";
import AccountDetail from "./tabs/AccountDetail";
import {
  AccountFacility,
  handleLoanAccActionButtons,
  AmountFormat,
} from "../../../../components/facilities/AccountFacility";
import Transactions from "./tabs/transactions/Transactions";
import LoanTrancheDetails from "./tabs/LoanTrancheDetails";
import Charges from "./tabs/charges/Charges";
import ManageStandingInstructions from "./tabs/standingInstructions/ManageStandingInstructions";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const columns = [
  {
    title: "Original",
    dataIndex: "original",
  },
  {
    title: "Paid",
    dataIndex: "paid",
  },
  {
    title: "Waived",
    dataIndex: "waived",
  },
  {
    title: "Written Off",
    dataIndex: "writtenOff",
  },
  {
    title: "Outstanding",
    dataIndex: "outstanding",
  },
  {
    title: "Over Due",
    dataIndex: "overdue",
  },
];

const LoanAccountDetails = (props) => {
  //DECLARED VARIABLES
  const { userData, loanTableList } = props;
  const { session } = userData;
  const { monthList } = appStatic;
  const navigate = useNavigate();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState([]);
  const [transactionsList, setTransactionsList] = useState([]);
  const [repaymentScheduleList, setRepaymentScheduleList] = useState([]);
  const [disbursementDetailsList, setDisbursementDetailsList] = useState([]);
  const [chargesList, setChargesList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("accountDetail");
  const [clientOfficeData, setClientOfficeData] = useState({
    officeId: "",
    officeName: "",
  });
  const [menuProps, setMenuProps] = useState({
    items: [],
  });

  const tabList = [
    {
      key: "accountDetail",
      label: "Account Detail",
    },
    {
      key: "repaymentSchedule",
      label: "Repayment Schedule",
    },
    {
      key: "loanTrancheDetails",
      label: "Loan Tranche Details",
    },
    {
      key: "transactions",
      label: "Transactions",
      disabled: !BOM.HasPermission("READ_LOAN"),
    },
    {
      key: "charges",
      label: "Charges",
      disabled: !BOM.HasPermission("READ_LOANCHARGE"),
    },
    {
      key: "loanDocuments",
      label: "Loan Documents",
    },
    {
      key: "notes",
      label: "Notes",
      disabled: !BOM.HasPermission("READ_LOANNOTE"),
    },
    {
      key: "standingInstruction",
      label: "Standing Instructions",
      // disabled: !BOM.HasPermission("READ_SAVINGNOTE")
    },
    // {
    //   key: "clientRisk",
    //   label: "Client Risk",
    // },
  ];

  useEffect(() => {
    console.log(state);
    getClientById();
    // getDetailById();
  }, []);

  const getClientById = () => {
    const url = `${apiConfig.Clients}/${state.clientId}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = {
          officeId: objList.officeId,
          officeName: objList.officeName,
        };

        console.log(temp);

        setClientOfficeData(temp);

        getDetailById(temp);
      }
    });
  };

  const getDetailById = (temp) => {
    const params = {
      associations: "all",
      exclude: "guarantors,futureSchedule",
    };

    const url = `${apiConfig.LoanAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAccountDetails(objDetail);
        let tempTransactionsArray = [];
        let tempRepaymentScheduleArray = [];
        let tempDisbursementDetails = [];
        let tempChargesArray = [];

        objDetail?.transactions?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.date
              ? BOM.DateTime(element?.date, "only-date")
              : "-",
            office: element?.officeName ? element?.officeName : "-",
            transactionType: element?.type ? element?.type?.value : "-",
            amount: element?.amount
              ? element?.amount
              : element?.amount === 0
              ? "0"
              : "-",
            interest: element?.interestPortion
              ? element?.interestPortion
              : element?.interestPortion === 0
              ? "0"
              : "-",
            principal: element?.principalPortion
              ? element?.principalPortion
              : element?.principalPortion === 0
              ? "0"
              : "-",
            fees: element?.feeChargesPortion
              ? element?.feeChargesPortion
              : element?.feeChargesPortion === 0
              ? "0"
              : "-",
            penalties: element?.penaltyChargesPortion
              ? element?.penaltyChargesPortion
              : element?.penaltyChargesPortion === 0
              ? "0"
              : "-",
            loanBalance: element?.outstandingLoanBalance
              ? element?.outstandingLoanBalance
              : element?.outstandingLoanBalance === 0
              ? "0"
              : "-",
            debit: element?.debit ? element?.debit : "-",
            credit: element?.amount ? element?.amount : "-",
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
            manuallyReversed: element?.manuallyReversed,
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            penalty: element?.penalty === false ? "Fee" : "Penalty",
            paymentDueAt: element?.chargeTimeType
              ? element?.chargeTimeType.value
              : "-",
            dueAsOf: element?.dueDate
              ? BOM.DateTime(element?.dueDate, "only-date")
              : "-",
            calculationType: element?.chargeCalculationType
              ? element?.chargeCalculationType.value
              : "-",
            due: `${element?.currency.displaySymbol}${element?.amount}`,
            paid: `${element?.currency.displaySymbol}${element?.amountPaid}`,
            waived: `${element?.currency.displaySymbol}${element?.amountWaived}`,
            outstanding: `${element?.currency.displaySymbol}${element?.amountOutstanding}`,
          });
        });

        objDetail?.repaymentSchedule?.periods?.forEach((element) => {
          tempRepaymentScheduleArray.push({
            key: element?.id,
            id: element?.id,
            date: element?.dueDate
              ? BOM.DateTime(element?.dueDate, "only-date")
              : "-",
            paidDate: element?.obligationsMetOnDate
              ? BOM.DateTime(element?.obligationsMetOnDate, "only-date")
              : "-",
            days: element?.daysInPeriod ? element?.daysInPeriod : "-",
            principalDue: element?.principalDue ? element?.principalDue : "-",
            balanceOfLoan: element?.principalLoanBalanceOutstanding
              ? element?.principalLoanBalanceOutstanding
              : "-",
            interest: element?.interestDue ? element?.interestDue : "-",
            fees: element?.feeChargesDue
              ? element?.feeChargesDue
              : element?.feeChargesDue === 0
              ? "0"
              : "-",
            penalties: element?.penaltyChargesDue
              ? element?.penaltyChargesDue
              : element?.penaltyChargesDue === 0
              ? "0"
              : "-",
            due: element?.totalDueForPeriod
              ? element?.totalDueForPeriod
              : element?.totalDueForPeriod === 0
              ? "0"
              : "-",
            paid: element?.principalPaid
              ? element?.principalPaid
              : element?.principalPaid === 0
              ? "0"
              : "-",
            inAdvance: element?.totalPaidInAdvanceForPeriod
              ? element?.totalPaidInAdvanceForPeriod
              : element?.totalPaidInAdvanceForPeriod === 0
              ? "0"
              : "-",
            late: element?.totalPaidLateForPeriod
              ? element?.totalPaidLateForPeriod
              : element?.totalPaidLateForPeriod === 0
              ? "0"
              : "-",
            outstanding: element?.totalOutstandingForPeriod
              ? element?.totalOutstandingForPeriod
              : "-",
          });
        });

        objDetail?.disbursementDetails?.forEach((element) => {
          tempDisbursementDetails.push({
            key: element?.id,
            id: element?.id,
            expectedDisbursementOn: element?.expectedDisbursementDate
              ? BOM.DateTime(element?.expectedDisbursementDate, "only-date")
              : "-",
            disbursementOn: element?.disbursementDate
              ? BOM.DateTime(element?.disbursementDate, "only-date")
              : "-",
            principal: element?.principal ? element?.principal : "-",
          });
        });

        setDisbursementDetailsList(tempDisbursementDetails);
        setTransactionsList(tempTransactionsArray);
        setChargesList(tempChargesArray);
        setRepaymentScheduleList(tempRepaymentScheduleArray);

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleLoanAccActionButtons(objDetail),
          onClick: (e) => {
            const item = handleLoanAccActionButtons(objDetail).find(
              (element) => element.key === e.key
            );

            if (item) {
              return navigate(item.route, {
                state: {
                  ...state,
                  accountNo: objDetail.accountNo,
                  actionLabel: item.label,
                  branchId: temp.officeId,
                },
              });
            }
          },
        });

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const onTabChange = (key) => {
    // console.log(key);
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    accountDetail: <AccountDetail accountDetails={accountDetails} />,
    repaymentSchedule: (
      <RepaymentSchedule
        repaymentScheduleList={repaymentScheduleList}
        accountDetails={accountDetails}
      />
    ),
    loanTrancheDetails: (
      <LoanTrancheDetails
        disbursementDetailsList={disbursementDetailsList}
        accountDetails={accountDetails}
      />
    ),
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        state={state}
        userData={userData}
      />
    ),
    charges: (
      <Charges chargesList={chargesList} state={state} userData={userData} />
    ),

    loanDocuments: <LoanDocuments />,
    notes: <Notes />,
    clientRisk: <ClientRisk />,
    standingInstruction: (
      <ManageStandingInstructions
        useForm={useForm}
        state={state}
        userData={userData}
        clientOfficeData={clientOfficeData}
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.loanAccountDetail}
        pageItems={
          state.variant
            ? staticConfig.viewLoanApprovalBreadcrumbItems
            : staticConfig.loanDetailBreadcrumbItems
        }
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />

            <Row style={{ marginBottom: 30, padding: 10 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <AccountFacility
                  accountName={accountDetails?.clientName}
                  accountNo={accountDetails?.accountNo}
                  status={accountDetails?.status}
                  accDetail={accountDetails}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 30 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.currentBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.totalOutstanding}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={`Arrears By`}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.totalOverdue}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>
            </Row>

            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <LoanDetails accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <PerformanceHistory accountDetails={accountDetails} />
              </Col>
            </Row>
            <Table columns={columns} dataSource={loanTableList} />
          </Form>
        </Card>
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LoanAccountDetails);

function LoanDetails(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.accountInformation}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.disbursementDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.FormatArrayDate(
                  accountDetails?.timeline?.actualDisbursementDate
                )}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.loanPurpose}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.loanPurpose
                  ? accountDetails?.loanPurpose
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.loanOfficer}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.loanOfficerName
                  ? accountDetails?.loanOfficerName
                  : "Unassigned"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.currency}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.displayLabel}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.proposedAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.proposedPrincipal}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.approvedAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.approvedPrincipal}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.disburseAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.summary?.principalDisbursed}
              </Text>
            </Col>
          </Row>
        </div>

        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.status}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.status?.value}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function PerformanceHistory(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            Performance History
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>No of Repayments </Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.numberOfRepayments}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>Maturity Date</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {" "}
                {BOM.FormatArrayDate(
                  accountDetails?.timeline?.expectedMaturityDate
                )}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
